import { api, ApiRequestConfig } from 'api';
import { ApplicationForm, TConfigurator } from './types';

export type FetchConfiguratorsParams = {
	regionCode: string;
	categoryId: string;
	types?: 'project';
};

export const fetchConfigurators = (
	url: string,
	params: FetchConfiguratorsParams,
	config?: ApiRequestConfig
): Promise<{ configurators: TConfigurator[] }> => api.get(url, params, config);

type SendFormParams = {
	type: string;
	channel: string;
	regionId: number;
	storeId: number;
	contact: ApplicationForm;
};

export const sendApplicationForm = (
	url: string,
	params: SendFormParams,
	config?: ApiRequestConfig
): Promise<{ leadId: string }> => api.post(url, params, config);
